<mat-card
  [style.grid-column]="'span ' + colSpan"
  [style.grid-row]="'span ' + rowSpan"
  >
  @if (title) {
    <mat-card-header>
      <mat-card-title>{{ title }}</mat-card-title>
    </mat-card-header>
  }
  <mat-card-content>
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
